import React from 'react';

export function SearchByPeriodInnovation() {
  return <h1>Inovação - Consulta por Período</h1>;
}
